import { memo } from 'react'

import { Table, Text, colors } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsInvoiceStatusEnum } from 'generated/resources/graphql'

import { SaleInvoiceStatus } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/saleInvoiceStatus'

const SELECTED_CELL_STYLE = {
  borderLeft: `4px solid ${colors.viridian1000}`,
  paddingLeft: '20px',
}

const DEFAULT_CELL_STYLE = {
  borderLeft: 'none',
  paddingLeft: '24px',
}

export interface RelatedFinancialDocumentsRowProps {
  number: string
  amount: string
  operationDate: string
  issueDate: string
  onClick?: () => void
  selected?: boolean
  validated?: boolean
  registered?: boolean
  status?: FinanceValueObjectsInvoiceStatusEnum
}

export const RelatedFinancialDocumentsRow = memo<RelatedFinancialDocumentsRowProps>(
  ({
    number,
    amount,
    operationDate,
    issueDate,
    onClick,
    selected,
    validated,
    registered,
    status,
  }) => {
    return (
      <Table.Row clickable={!!onClick} onClick={onClick}>
        <Table.Cell style={selected ? SELECTED_CELL_STYLE : DEFAULT_CELL_STYLE}>
          <Text.Normal size="200" weight="medium" color="grey1000">
            {number}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal size="200" weight="normal" color="grey1000">
            {amount}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal size="200" weight="normal" color="grey1000">
            {operationDate}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal size="200" weight="normal" color="grey1000">
            {issueDate}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <SaleInvoiceStatus validated={validated} registered={registered} status={status} />
        </Table.Cell>
      </Table.Row>
    )
  }
)

RelatedFinancialDocumentsRow.displayName = 'RelatedFinancialDocumentsRow'
